export enum ScheduledRoutes {
  scheduled = 'user.scheduled',
  scheduledIndex = 'user.scheduled.index',
  details = 'user.scheduled.details',
  detailsEmail = 'user.scheduled.detailsEmail',
  upcoming = 'user.scheduled.upcoming',
  upcomingOverview = 'user.scheduled.upcoming.overview',
  upcomingOverviewEmail = 'user.scheduled.upcoming.overviewEmail',
  paused = 'user.scheduled.paused',
  pausedOverview = 'user.scheduled.paused.overview',
  pausedOverviewEmail = 'user.scheduled.paused.overviewEmail',
  notSent = 'user.scheduled.notSent',
  notSentOverview = 'user.scheduled.notSent.overview',
  notSentOverviewEmail = 'user.scheduled.notSent.overviewEmail',
  completed = 'user.scheduled.completed',
  completedOverview = 'user.scheduled.completed.overview',
  completedOverviewEmail = 'user.scheduled.completed.overviewEmail',
  calendar = 'user.scheduled.calendar',
  edit = 'user.scheduled.edit',
  editEmail = 'user.scheduled.editEmail',
}

export const scheduledEmailIdRouteParam = 'scheduledEmailId' as const
